// @flow

export { default as cache } from 'universal/reducers/cache';
export { default as siteConfigs } from 'client/reducers/siteConfigs';
export { default as translations } from 'client/reducers/translations';
export { default as user } from 'client/reducers/user';
export const partnerName = (state: string | null = null) => state;
export const brand = (state: string = 'stride') => state;
export const phase3Enabled = (state: boolean | null = null) => state;
